// src/components/Footer.jsx

import React from "react";
import "./Footer.css";
import icons from "../assets/icons";

const Icon = icons["LogoSemMolduraIcon"];

const handleContact = (event) => {
  event.preventDefault();

  const phoneNumber = "5527992613367";
  const text = `Olá! Gostaria de um contato`;

  const encodedText = encodeURIComponent(text);
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedText}`;

  window.open(whatsappUrl, "_blank");
};

const Footer = () => {
  return (
    <footer className="footer-section">
      <div className="container footer-container">
        <div className="footer-logo-wrapper">
          <Icon className="footer-logo" />
        </div>

        {/* CONTATOS ATUALIZADOS */}
        <div className="footer-column">
          <h6>Contatos</h6>
          <p>
            <a href="#" onClick={handleContact}>
              +55 27 992613367
            </a>
            <br />
            <a href="mailto:contato@dbvision.tech">
              contato@dbvision.tech
            </a>{" "}
          </p>
        </div>

        {/* LOCALIZAÇÃO ATUALIZADA */}
        <div className="footer-column">
          <h6>Localização</h6>
          <p>Vila Velha - ES</p>
        </div>

        {/* REDES SOCIAIS */}
        <div className="footer-column">
          <h6>Redes Sociais</h6>
          <p>
            <a
              href="https://www.linkedin.com/company/vision-db/?viewAsMember=true"
              target="_blank"
              rel="noopener noreferrer"
            >
              LinkedIn
            </a>{" "}
          </p>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <p>
            &copy; {new Date().getFullYear()} DB Vision. Todos os direitos
            reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
